var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ApolloQuery',{staticClass:"reader",attrs:{"query":_vm.query,"variables":_vm.queryVariables,"update":_vm.queryUpdate},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ref_result = ref.result;
var error = ref_result.error;
var data = ref_result.data;
var isLoading = ref.isLoading;
return [(isLoading)?_c('LoaderBall'):(error)?_c('ErrorMessage',[_vm._v(" There was an error loading the requested data. ")]):(!(data || data.hasAnnotations))?_c('EmptyMessage'):[_c('Reader',{attrs:{"lines":data.lines}})]]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }